import remoteServices from './RemoteServices';
import {getCartToken} from '../utils/url';

export function getCheckoutSummaryLink(params = {}) {
  const cartToken = getCartToken();
  const searchParams = new URLSearchParams();

  // for metrics to track how stuff is going to cart
  searchParams.set('cart_source', 'lab');

  Object.keys(params).forEach(key => {
    searchParams.set(key, params[key]);
  });
  if (cartToken) {
    searchParams.set('token', cartToken);
  }
  return `${remoteServices.checkout}/summary?${searchParams.toString()}`;
}
